// extracted by mini-css-extract-plugin
export default {"subHeader":"SetUpDrawer_subHeader__qtlvt","description":"SetUpDrawer_description__Ss2G+"};